import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import userActions from '../actions/user'

export const useUser = () => {
  const data = useSelector((state) => {
    return get(state, 'app.userManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(userActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
